// Temporary file for local storage keys, in future this keys must be must be located in the appropriate entities

const CACHE_BASE_KEY = window?.location?.origin ?? 'mm-dash';

export const MAX_CACHED_PAIRS = 10;
export const FILTERS_KEY = 'filters';

export const PAIR_CONFIGS_CACHE_KEY = `${CACHE_BASE_KEY}/pair-configs`;

export const JWT_CACHE_KEY = `${CACHE_BASE_KEY}/jwt`;
export const USER_CACHE_KEY = `${CACHE_BASE_KEY}/user`;

export const JOB_ID_CACHE_KEY = `${CACHE_BASE_KEY}/job-id`;
export const APP_VERSION_CACHE_KEY = `${CACHE_BASE_KEY}/app-version`;
export const WEB3_AUTH_METHOD_CACHE_KEY = `${CACHE_BASE_KEY}/web3-auth-method`;

export const THEME_CACHE_KEY = `${CACHE_BASE_KEY}/theme`;
export const FILTERS_CACHE_KEY = `${CACHE_BASE_KEY}/filters`;
export const SIDEBAR_CACHE_KEY = `${CACHE_BASE_KEY}/sidebar-opened`;

export const SESSION_CLEAR_VERSION_KEY = `${CACHE_BASE_KEY}/session-clear-version`;
export const CURRENT_SESSION_CLEAR_VERSION = '2025-11-28-v1';
